<template lang="html">
  <button
    @click="clickBtn"
    :class="['btn-ceed', variant, disabled && 'disabled']"
  >
    <slot />
  </button>
</template>
<script>
export default {
  props: {
    variant: {
      type: String,
      default: "primary",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clickBtn: Function,
  },
};
</script>
<style lang="css" scoped>
.btn-ceed {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 4px;
  text-transform: uppercase;
  padding: 15px 24px 13px;
  border-radius: 15px;
  outline: none;
  stroke: none;
  border: none;
}
.btn-ceed.primary {
  color: #ffffff;
  background: radial-gradient(
    90% 90% at 49.72% 10%,
    rgba(51, 100, 126, 0.95) 0%,
    rgba(1, 54, 82, 0.95) 75.09%
  );
  transition: all 0.3s ease-in-out;
}
.btn-ceed.primary:hover {
  background: radial-gradient(
    90% 90% at 49.72% 10%,
    rgba(51, 100, 126, 0.75) 0%,
    rgba(1, 54, 82, 0.75) 75.09%
  );
}
.btn-ceed.primary:active {
  background: radial-gradient(
    90% 90% at 49.72% 10%,
    #1c506b 0%,
    #002538 75.09%
  );
}
.btn-ceed.primary.disabled {
  background: radial-gradient(
    69% 69% at 50% 31%,
    rgba(172, 172, 172, 0.97) 0%,
    rgba(180, 180, 180, 0.97) 100%
  ) !important;
}
.btn-ceed.secondary {
  color: #013652;
  background: #ffffff;
}
.btn-ceed.secondary:hover {
  color: #1c506b;
}
.btn-ceed.secondary:active {
  color: #002538;
}
.btn-ceed.secondary.disabled {
  color: #acacac;
}
.btn-ceed.link {
  padding: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #33647e;
  display: flex;
  align-items: center;
  background: transparent;
}
.btn-ceed.link::after {
  content: url("data:image/svg+xml,%3Csvg width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M-6.87533e-08 2.14286L5 7.5L-6.87533e-08 12.8571L1 15L8 7.5L1 0L-6.87533e-08 2.14286Z' fill='url(%23paint0_radial_2371_3913)' fill-opacity='0.97'/%3E%3Cdefs%3E%3CradialGradient id='paint0_radial_2371_3913' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(4 4.65) rotate(90) scale(10.35 5.52)'%3E%3Cstop stop-color='%2333647E'/%3E%3Cstop offset='1' stop-color='%23013652'/%3E%3C/radialGradient%3E%3C/defs%3E%3C/svg%3E%0A");
  margin-left: 10px;
  transition: all 0.5s;
}
.btn-ceed.link:hover::after {
  transform: translateX(10px);
}
</style>
